import React, { useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LanguageContext";

/**
 * Bandeau affiché tant que l'adresse e-mail n'est pas confirmée
 * (comptes créés avec e-mail + mot de passe). Sans confirmation, le serveur
 * refuse les opérations sur les pièces.
 */
const VerifyEmailBanner = () => {
  const { user, resendVerification, reloadVerification } = UserAuth();
  const { t } = useLang();
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user?.hasProfile || user.emailVerified) return null;

  const run = async (fn) => {
    setBusy(true);
    setMsg("");
    try {
      await fn();
    } catch (e) {
      setMsg(e?.code === "auth/too-many-requests" ? t("Trop de tentatives. Patiente quelques minutes puis réessaie.") : t("Une erreur est survenue. Veuillez réessayer."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-or-light border-b border-or/40 text-sm text-stone-800">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-2">
        <span>
          ✉️ {t("Confirme ton adresse e-mail : clique sur le lien envoyé à {email} (regarde aussi dans les spams).", { email: user.email })}
        </span>
        <div className="flex gap-2 ml-auto">
          <button
            disabled={busy}
            onClick={() =>
              run(async () => {
                const ok = await reloadVerification();
                if (!ok) setMsg(t("Pas encore confirmé. Clique sur le lien dans l'e-mail, puis réessaie."));
              })
            }
            className="px-3 py-1 rounded-full bg-prune text-white font-semibold text-xs hover:bg-prune-dark disabled:opacity-50"
          >
            {t("C'est fait")}
          </button>
          <button
            disabled={busy}
            onClick={() => run(async () => { await resendVerification(); setMsg(t("E-mail renvoyé !")); })}
            className="px-3 py-1 rounded-full border border-prune text-prune font-semibold text-xs hover:bg-white disabled:opacity-50"
          >
            {t("Renvoyer l'e-mail")}
          </button>
        </div>
        {msg && <span className="w-full text-xs text-stone-600">{msg}</span>}
      </div>
    </div>
  );
};

export default VerifyEmailBanner;
